"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YbxInfo = void 0;
var version_1 = require("./version");
var YbxInfo = (function () {
    function YbxInfo() {
    }
    YbxInfo.YbxSdkVersion = version_1.LIB_VERSION;
    return YbxInfo;
}());
exports.YbxInfo = YbxInfo;
//# sourceMappingURL=YbxInfo.js.map